import { HStack } from '@pets-ui/HStack/HStack'
import { SuccessOutlined } from '@pets-ui/icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonBind, type ButtonBindProps } from './ButtonBind'

const styles = stylex.create({
  cardFastLogin: {
    padding: '12px 16px',
  },
  cardDescription: {
    width: '100%',
  },
})

interface CardFastLoginProps extends Omit<ButtonBindProps, 'text' | 'title'> {
  title?: ReactNode
  onClick?: () => void
  icon: ReactElement
}

export function CardFastLogin(props: CardFastLoginProps) {
  const { t } = useTranslation()
  const { title, onClick, isBound = false, canUnBind, icon } = props

  return (
    <Paper elevation={4} rootStyle={styles.cardFastLogin}>
      <HStack alignItems="center" flexWrap="nowrap" gap={4}>
        <SvgIcon fontSize={24}>{icon}</SvgIcon>
        <VStack rootStyle={styles.cardDescription} gap={1}>
          <Text variant="body">{title}</Text>
          <HStack gap={0.5} alignItems="center">
            <Text color="grey" variant="caption">{isBound ? t('login.bound') : t('login.notBound')}</Text>
            {isBound && <SuccessOutlined fontSize={14} color={colors.green600} />}
          </HStack>
        </VStack>
        <ButtonBind
          isBound={isBound}
          canUnBind={canUnBind}
          onClick={onClick}
          text={t('login.bindAccount')}
        />
      </HStack>
    </Paper>
  )
}
